"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _link = _interopRequireDefault(require("@insided/deprecated-preact-components/menu/link"));

var _list = _interopRequireDefault(require("@insided/deprecated-preact-components/menu/list"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var QuickLinksList = function QuickLinksList(_ref) {
  var _getItemProps = _ref.getItemProps,
      highlightedIndex = _ref.highlightedIndex,
      quickLinksClean = _ref.quickLinksClean;
  return (0, _preact.h)(_list.default, {
    className: "main-menu-list--quicklinks",
    getItemProps: function getItemProps(idx) {
      return _getItemProps({
        item: quickLinksClean[idx],
        className: (0, _classnames.default)('main-menu-list__item', 'main-menu-list__item--no-hover', {
          'main-menu-list__item--highlighted': idx === highlightedIndex
        })
      });
    }
  }, quickLinksClean.map(function (item) {
    return (0, _preact.h)(_link.default, {
      track: {
        type: "Mega Menu click on ".concat(item.phrase.p),
        event_source: 'control'
      },
      key: item.url,
      href: (0, _absoluteUrlRuntime.resolveUrl)(item.url)
    }, (0, _preact.h)(_phrase.default, item.phrase));
  }));
};

var _default = QuickLinksList;
exports.default = _default;